var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeveloper000000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 480,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350.59339,166.97671c-1.2305,-88.367 -79.742,-162.4 -172.54,-162.4c-72.41,-0.44922 -141.07,45.863 -163.46,109.82c-15.121,33.32 -7.8398,94.246 -1.457,147.78c2.0703,17.527 4.0898,34.105 4.9844,47.824c1.2539,18.469 1.0117,37.012 -0.73047,55.441l-9.0156,95.145c-0.30078,3.1484 0.74609,6.2812 2.8789,8.6172c2.1367,2.3359 5.1562,3.6602 8.3242,3.6445l226.3,2.5742l-0.00391,0.00391c3.0391,0 5.9492,-1.2305 8.0625,-3.418c2.1133,-2.1875 3.2461,-5.1367 3.1367,-8.1758l-2.1289,-57.344l65.129,4.3125c5.5781,0.36719 10.574,-3.4297 11.707,-8.9023l16.406,-79.801l46.031,-4.3672c3.4961,-0.33984 6.6328,-2.2969 8.4688,-5.2891c1.8359,-2.9922 2.1641,-6.6758 0.88281,-9.9453l-52.97543,-135.51961zm-213.75,63.504l-17.586,13.887l-43.508,-54.988l43.512,-54.992l17.586,13.887l-32.652,41.105l32.648,41.101zm48.273,36.398l-26.992,-151.2l22.062,-3.9219l26.992,151.2l-22.062,3.9219zm60.871,-22.398l-17.586,-13.887l32.594,-41.215l-32.48,-41.105l17.586,-13.887l43.344,54.992l-43.458,55.102z",
    fill: "#000000"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper000000);
export default __webpack_public_path__ + "static/media/developer_000000.526cf8471c31d34741e08dffca9bc7f8.svg";
export { ForwardRef as ReactComponent };